import { useCallback } from "preact/hooks";
import useBotRequest from "./useBotRequest.js";

export function useJoinChannel({
  twitchUsername,
  twitchTokenValidated,
  twitchAccessToken,
  twitchBroadcasterID,
}) {
  const handleBotRequest = useBotRequest({
    twitchUsername,
    twitchAccessToken,
    twitchBroadcasterID,
  });

  return useCallback(() => {
    const url = `${import.meta.env.VITE_TWITCH_URI}/webhooks/twitch/manage/create`;

    if (!twitchAccessToken || !twitchTokenValidated) {
      return { success: false, webhooks: null };
    }

    return handleBotRequest(url);
  }, [handleBotRequest, twitchAccessToken, twitchTokenValidated]);
}

export function useLeaveChannel({ twitchUsername, twitchAccessToken, twitchBroadcasterID }) {
  const handleBotRequest = useBotRequest({
    twitchUsername,
    twitchAccessToken,
    twitchBroadcasterID,
  });
  return useCallback(() => {
    const url = `${import.meta.env.VITE_TWITCH_URI}/webhooks/twitch/manage/delete`;
    return handleBotRequest(url);
  }, [handleBotRequest]);
}
